var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_2810)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 2.49998C5.85754 2.49998 2.49967 5.85784 2.49967 9.99998C2.49967 14.1421 5.85754 17.5 9.99967 17.5C14.1418 17.5 17.4997 14.1421 17.4997 9.99998C17.4997 5.85784 14.1418 2.49998 9.99967 2.49998ZM0.833008 9.99998C0.833008 4.93737 4.93706 0.833313 9.99967 0.833313C15.0623 0.833313 19.1663 4.93737 19.1663 9.99998C19.1663 15.0626 15.0623 19.1666 9.99967 19.1666C4.93706 19.1666 0.833008 15.0626 0.833008 9.99998Z",
    fill: "#82858D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 4.16669C10.4606 4.16669 10.8337 4.53978 10.8337 5.00002V9.48499L13.7063 10.9213C14.118 11.1272 14.2848 11.6277 14.079 12.0394C13.8732 12.451 13.3726 12.6179 12.961 12.412L9.62765 10.7454C9.34533 10.6042 9.16699 10.3157 9.16699 10V5.00002C9.16699 4.53978 9.54009 4.16669 10.0003 4.16669Z",
    fill: "#82858D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_2810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.a1a5de358771a981d2716d68e54b4099.svg";
export { ForwardRef as ReactComponent };